// extracted by mini-css-extract-plugin
export var chip = "_4s-0";
export var filterDropdown = "_4s-5";
export var filterItem = "_4s-6";
export var icon = "_4s-1";
export var removeButton = "_4s-3";
export var removeIcon = "_4s-4";
export var separator = "_4s-2";